import * as actions from '../actions'

const defaultState = null

export default function hsm(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_HSM:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        case actions.CLEAN_HSM:
            return defaultState

        default:
            return state
    }
}
